import React, { Fragment, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { Dialog, Transition } from "@headlessui/react";

import Card from "components/Card";

export default function Services() {
  const [isBookResidentialDialogOpen, setIsBookResidentialDialogOpen] =
    useState(false);
  const [isBookCommercialDialogOpen, setIsBookCommercialDialogOpen] =
    useState(false);

  return (
    <div className="bg-ciGreen bg-opacity-70 pt-8 pb-14 flex flex-col items-center">
      <p
        className="leading-snug tracking-wider text-4xl text-white font-extrabold"
        role="heading"
        aria-level="1"
      >
        Services
      </p>

      <p className="text-white">Don't see a time that works for you?</p>
      <div className="flex items-center space-x-2 text-white pb-3">
        <p>Give us a call at</p>
        <a href="tel:+17062065512">
          <FontAwesomeIcon icon={faPhone} /> (706) 206-5512
        </a>
      </div>

      <div className="flex flex-col lg:flex-row items-center justify-center w-full">
        <Card
          backgroundImage="bg-residential"
          text="Book Residential"
          alt="Residential booking"
          onClick={() => setIsBookResidentialDialogOpen(true)}
        ></Card>
        <Transition appear show={isBookResidentialDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsBookResidentialDialogOpen(false)}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded">
                  <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
                    Book a Residential Inspection
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Here are the residential services we offer.
                    </p>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                      onClick={() => setIsBookResidentialDialogOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>

        <Card
          backgroundImage="bg-commercial"
          text="Book Commercial"
          alt="Commercial booking"
          onClick={() => setIsBookCommercialDialogOpen(true)}
        ></Card>
        <Transition appear show={isBookCommercialDialogOpen} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-10 overflow-y-auto"
            onClose={() => setIsBookCommercialDialogOpen(false)}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded">
                  <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
                    Book a Commercial Inspection
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Here are the commercial services we offer.
                    </p>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center px-4 py-2 text-sm font-medium bg-ciGreen-light text-white border border-transparent rounded hover:bg-ciGreen-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-green-500"
                      onClick={() => setIsBookCommercialDialogOpen(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    </div>
  );
}
